import { navItems } from '@/mocks/content';

export default function SiteFooter() {
  const handleNav = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2 font-heading text-xl font-bold text-background-50">
              <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-base">
                <i className="ri-book-marked-line" />
              </span>
              漂亮的保姆
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300 max-w-sm">
              本站是围绕作品《漂亮的保姆》的阅读资源信息整理页，汇总小说与漫画的无删减 TXT 阅读相关信息，帮助你快速了解作品并选择适合的阅读方式。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">页面导航</h4>
            <ul className="mt-4 grid grid-cols-2 gap-2">
              {navItems.map((item) => (
                <li key={item.id}>
                  <button
                    type="button"
                    onClick={() => handleNav(item.id)}
                    className="text-sm text-background-300 hover:text-primary-300 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">阅读提示</h4>
            <ul className="mt-4 space-y-2 text-sm text-background-300">
              <li className="flex items-start gap-2">
                <i className="ri-information-line mt-0.5" />
                页面内容为阅读资源信息整理，仅供参考。
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line mt-0.5" />
                本页不保存、不上传任何阅读记录。
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-device-line mt-0.5" />
                请使用支持 TXT 的阅读器打开文本资源。
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-background-400">
          <p>© {new Date().getFullYear()} 漂亮的保姆 · 阅读资源信息站</p>
          <p>本站为信息整理页面，不提供账号、付费与在线提交功能。</p>
        </div>
      </div>
    </footer>
  );
}